"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Drawer');

function getTransitionEndEventName() {
  var transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
  };
  var bodyStyle = document.body.style;

  for (var transition in transitions) {
    if (bodyStyle[transition] !== undefined) {
      return transitions[transition];
    }
  }
}

var transitionEndEventName = getTransitionEndEventName();

function Drawer(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      isOpen = _ref.isOpen,
      width = _ref.width,
      side = _ref.side,
      closeTimeout = _ref.closeTimeout,
      onAfterOpen = _ref.onAfterOpen,
      onRequestClose = _ref.onRequestClose,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnEsc = _ref.shouldCloseOnEsc,
      contentStyles = _ref.contentStyles,
      style = _ref.style,
      onTransitionEnds = _ref.onTransitionEnds,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "isOpen", "width", "side", "closeTimeout", "onAfterOpen", "onRequestClose", "shouldCloseOnOverlayClick", "shouldCloseOnEsc", "contentStyles", "style", "onTransitionEnds"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Drawer.overrides);
  var drawerRef = (0, _react.useRef)(document); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, classes[side], classNameProp);
  var contentStyle = {
    width: width
  };
  if (side && ['top', 'bottom'].includes(side)) contentStyle = {
    height: width
  };
  var onAfterOpenCb = (0, _react.useCallback)(function () {
    if (!onTransitionEnds && !onAfterOpen) return;
    if (onAfterOpen) return onAfterOpen();
    var drawerTransitionEl = drawerRef.current.querySelector(".".concat(classes.root));
    drawerTransitionEl.addEventListener(transitionEndEventName, onTransitionEnds);
    return function () {
      return drawerTransitionEl.removeEventListener(transitionEndEventName, onTransitionEnds);
    };
  }, [classes.root, onAfterOpen, onTransitionEnds]);
  var rootProps = (0, _extends2.default)({
    ariaHideApp: false,
    isOpen: isOpen,
    closeTimeoutMS: closeTimeout,
    style: (0, _extends2.default)({
      content: (0, _extends2.default)({}, contentStyle, contentStyles)
    }, style),
    overlayClassName: classes.overlay,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: false,
    shouldCloseOnEsc: false
  }, override.root);
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, (0, _extends2.default)({
    onAfterOpen: onAfterOpenCb,
    className: rootClassName
  }, rootProps), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    className: classes.Text
  }, override.Text), children));
}

Drawer.overrides = ['root', 'Text'];
Drawer.defaultProps = {
  width: '500px',
  side: 'right',
  closeTimeout: 500,
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true
};
process.env.NODE_ENV !== "production" ? Drawer.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  children: _propTypes.default.any,
  isOpen: _propTypes.default.bool.isRequired,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  side: _propTypes.default.oneOf(['right', 'left']),

  /**Milliseconds to wait before closing the drawer */
  closeTimeout: _propTypes.default.number,

  /** Function that will be called after the drawer has opened */
  onAfterOpen: _propTypes.default.func,

  /** Function that will be called when the drawer is requested to be closed (either by clicking on overlay or pressing ESC) */
  onRequestClose: _propTypes.default.func,

  /** Function that will be called after the drawer has opened and transition has ended*/
  onTransitionEnds: _propTypes.default.func,

  /** Close on overlay click, you must implement onRequestClose. */
  shouldCloseOnOverlayClick: _propTypes.default.bool,

  /** Close on ESC, you must implement onRequestClose. */
  shouldCloseOnEsc: _propTypes.default.bool,
  contentStyles: _propTypes.default.object
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Drawer);

exports.default = _default;